var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13V5.5C8 5.10218 8.15804 4.72064 8.43934 4.43934C8.72064 4.15804 9.10218 4 9.5 4C9.89782 4 10.2794 4.15804 10.5607 4.43934C10.842 4.72064 11 5.10218 11 5.5V12",
    stroke: "#2B2B32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5V3.5C11 3.30302 11.0388 3.10796 11.1142 2.92597C11.1896 2.74399 11.3001 2.57863 11.4393 2.43934C11.5786 2.30005 11.744 2.18956 11.926 2.11418C12.108 2.0388 12.303 2 12.5 2C12.697 2 12.892 2.0388 13.074 2.11418C13.256 2.18956 13.4214 2.30005 13.5607 2.43934C13.6999 2.57863 13.8104 2.74399 13.8858 2.92597C13.9612 3.10796 14 3.30302 14 3.5V12",
    stroke: "#2B2B32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5C14 5.10218 14.158 4.72064 14.4393 4.43934C14.7206 4.15804 15.1022 4 15.5 4C15.8978 4 16.2794 4.15804 16.5607 4.43934C16.842 4.72064 17 5.10218 17 5.5V12",
    stroke: "#2B2B32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 7.5C16.9999 7.10218 17.158 6.72064 17.4393 6.43934C17.7206 6.15804 18.1021 6 18.4999 6C18.8978 6 19.2793 6.15804 19.5606 6.43934C19.8419 6.72064 19.9999 7.10218 19.9999 7.5V16C19.9999 17.5913 19.3678 19.1174 18.2426 20.2426C17.1174 21.3679 15.5912 22 13.9999 22H11.9999H12.2079C11.2143 22.0002 10.2361 21.7535 9.36132 21.2823C8.48652 20.811 7.74245 20.1299 7.19594 19.3C7.13035 19.2002 7.06502 19.1002 6.99994 19C6.68794 18.521 5.59294 16.612 3.71394 13.272C3.52239 12.9315 3.47122 12.5298 3.57132 12.1522C3.67142 11.7745 3.91489 11.4509 4.24994 11.25C4.60682 11.0359 5.02501 10.9471 5.4381 10.9978C5.85119 11.0486 6.23548 11.2359 6.52994 11.53L7.99994 13",
    stroke: "#2B2B32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/Hand.91674e97.svg";
export { ForwardRef as ReactComponent };